const STORAGE_KEY = 'vipClickStats';

export function trackClick(campaignId) {
  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

  const raw = localStorage.getItem(STORAGE_KEY);
  const data = raw ? JSON.parse(raw) : {};

  if (!data[campaignId]) {
    data[campaignId] = {};
  }
  if (!data[campaignId][today]) {
    data[campaignId][today] = 0;
  }

  data[campaignId][today] += 1;

  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getClicksByCampaign(campaignId) {
  const raw = localStorage.getItem(STORAGE_KEY);
  const data = raw ? JSON.parse(raw) : {};
  return data[campaignId] || {};
}

export function getAllCampaignStats() {
  const raw = localStorage.getItem(STORAGE_KEY);
  const data = raw ? JSON.parse(raw) : {};
  return data;
}
